import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from '@shared/contexts/ThemeContext';
import { ConfigProvider } from '@shared/contexts/ConfigContext';
import { RoleProvider } from '@/contexts/RoleContext';
import { AuthProvider } from '@/hooks/useAuth';
import { apiClient } from '@/services/api';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <ConfigProvider
            fetchPublicConfig={() => apiClient.getPublicConfig()}
            fetchConfig={() => apiClient.getConfig()}
            saveConfig={(updates) => apiClient.updateConfig(updates)}
          >
            <RoleProvider>
              <AuthProvider>
                <App />
                <Toaster position="top-right" />
              </AuthProvider>
            </RoleProvider>
          </ConfigProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
